document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".custom_text_animation_left");
  if (!section) return;

  const textElements = section.querySelectorAll(
    ".text-block p, .text-block h1, rte-formatter p"
  );

  function typeWriter(el, text, speed, callback) {
    el.textContent = "";

    // ✅ Fade in on first character — no snap
    el.style.transition = "opacity 0.25s ease";
    el.style.opacity = "1";

    let i = 0;
    const interval = setInterval(() => {
      if (i < text.length) {
        el.textContent += text.charAt(i);
        i++;
      } else {
        clearInterval(interval);

        // ✅ Smoothly release reserved height
        el.style.transition = "min-height 0.45s cubic-bezier(0.22, 1, 0.36, 1)";
        el.style.minHeight = el.scrollHeight + "px";

        setTimeout(() => {
          el.style.transition = "";
          el.style.minHeight = "";
        }, 460);

        if (callback) callback();
      }
    }, speed);
  }

  function animateSequentially(elements, index = 0) {
    if (index >= elements.length) return;

    const el = elements[index];

    if (index === 0) {
      elements.forEach((e) => {
        // ✅ Lock full natural height BEFORE hiding
        const height = e.getBoundingClientRect().height;
        e.style.minHeight = height + "px";
        e.dataset.originalText = e.textContent.trim();

        // ✅ opacity:0 instead of visibility:hidden
        // Element still holds its layout space — no reflow during typing
        e.style.opacity = "0";
        e.style.transition = "";
      });
    }

    const originalText = el.dataset.originalText;
    const delay = index === 0 ? 200 : 300;

    setTimeout(() => {
      const speed = index === 1 ? 55 : 35;
      typeWriter(el, originalText, speed, () => {
        animateSequentially(elements, index + 1);
      });
    }, delay);
  }

  animateSequentially(Array.from(textElements));
});

// page on load image animation
document.addEventListener("DOMContentLoaded", function () {
  const imageSection = document.querySelector(".custom_text_animation_right");
  if (!imageSection) return;

  const imageBlock = imageSection.querySelector(".image-block");
  const img = imageSection.querySelector(".image-block__image");
  if (!img || !imageBlock) return;

  // ✅ Wrap image for clean clip-path control
  const wrapper = document.createElement("div");
  wrapper.style.cssText = `
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    clip-path: inset(100% 0% 0% 0%);
    transition: clip-path 1.4s cubic-bezier(0.77, 0, 0.175, 1);
    will-change: clip-path;
  `;
  imageBlock.parentNode.insertBefore(wrapper, imageBlock);
  wrapper.appendChild(imageBlock);

  // ✅ Image starts zoomed + shifted down
  img.style.cssText += `
    transform: scale(1.1) translateY(20px);
    transition: transform 1.6s cubic-bezier(0.77, 0, 0.175, 1);
    will-change: transform;
    display: block;
    width: 100%;
  `;

  // ✅ Floating breathing effect
  function startFloating(el) {
    let floatUp = false;
    setTimeout(() => {
      el.style.transition = "transform 4s ease-in-out";
      function float() {
        floatUp = !floatUp;
        el.style.transform = floatUp
          ? "scale(1) translateY(-10px)"
          : "scale(1) translateY(0px)";
      }
      float();
      setInterval(float, 4000);
    }, 200);
  }

  // ✅ Mouse parallax on desktop
  if (window.innerWidth > 768) {
    document.addEventListener("mousemove", function (e) {
      const xPos = (e.clientX / window.innerWidth - 0.5) * 15;
      const yPos = (e.clientY / window.innerHeight - 0.5) * 10;
      wrapper.style.transform = `translate(${xPos}px, ${yPos}px)`;
      wrapper.style.transition =
        "transform 0.8s ease-out, clip-path 1.4s cubic-bezier(0.77, 0, 0.175, 1)";
    });
  }

  // ✅ Fire immediately on page load — small delay for browser paint
  setTimeout(() => {
    // Curtain wipes up
    wrapper.style.clipPath = "inset(0% 0% 0% 0%)";

    // Image zooms to natural + rises into place
    img.style.transform = "scale(1) translateY(0px)";

    // Start floating after reveal finishes
    setTimeout(() => {
      startFloating(img);
    }, 1600);
  }, 300); // 300ms after DOM ready — feels natural on page load
});

// fadup animation
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".curated-categories");
  if (!section) return;

  // ✅ Get all direct animatable children inside the section
  const animatableItems = section.querySelectorAll(
    ".text-block, .image-block, .group-block, .button, .button-secondary, rte-formatter, .card, [class*='block'], [class*='item'], [class*='card'], [class*='product']",
  );

  // ✅ Set initial hidden state for section and all children
  section.style.opacity = "0";
  section.style.transform = "translateY(60px)";
  section.style.transition = "opacity 0.8s ease, transform 0.8s ease";
  section.style.willChange = "opacity, transform";

  animatableItems.forEach((el, i) => {
    el.style.opacity = "0";
    el.style.transform = "translateY(100px)";
    el.style.transition = `opacity 0.7s ease ${i * 0.1}s, transform 0.7s ease ${i * 0.1}s`;
    el.style.willChange = "opacity, transform";
  });

  // ✅ Intersection Observer — triggers when section enters viewport
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Reveal section first
          section.style.opacity = "1";
          section.style.transform = "translateY(0)";

          // Then stagger children in
          animatableItems.forEach((el, i) => {
            setTimeout(() => {
              el.style.opacity = "1";
              el.style.transform = "translateY(0)";
            }, i * 120); // 120ms stagger between each child
          });

          // ✅ Stop observing after first trigger
          observer.unobserve(section);
        }
      });
    },
    {
      threshold: 0.1, // Trigger when 10% of section is visible
      rootMargin: "0px 0px -60px 0px", // Trigger slightly before fully in view
    },
  );

  observer.observe(section);
});

// Full page animation home
document.addEventListener("DOMContentLoaded", function () {
  // ============================================================
  // ✅ STYLES — Strong visible animations
  // ============================================================
  const style = document.createElement("style");
  style.textContent = `
    .anim-up    { opacity: 0 !important; transform: translateY(70px) !important; }
    .anim-left  { opacity: 0 !important; transform: translateX(-80px) !important; }
    .anim-right { opacity: 0 !important; transform: translateX(80px) !important; }
    .anim-scale { opacity: 0 !important; transform: scale(0.75) !important; }
    .anim-flip  { opacity: 0 !important; transform: perspective(800px) rotateX(25deg) translateY(50px) !important; }
    .anim-blur  { opacity: 0 !important; filter: blur(10px) !important; transform: translateY(25px) !important; }
    .anim-pop   { opacity: 0 !important; transform: scale(0.4) rotate(-8deg) !important; }
    .anim-down  { opacity: 0 !important; transform: translateY(-50px) !important; }

    .anim-up, .anim-left, .anim-right,
    .anim-scale, .anim-flip, .anim-blur,
    .anim-pop, .anim-down {
      transition:
        opacity 1s cubic-bezier(0.22, 1, 0.36, 1),
        transform 1s cubic-bezier(0.22, 1, 0.36, 1),
        filter 1s ease !important;
      will-change: opacity, transform;
    }

    .anim-in {
      opacity: 1 !important;
      transform: none !important;
      filter: none !important;
    }

    // .anim-card-hover {
    //   transition: transform 0.4s ease, box-shadow 0.4s ease !important;
    // }
    // .anim-card-hover:hover {
    //   transform: translateY(-8px) scale(1.01) !important;
    //   box-shadow: 0 24px 60px rgba(0,0,0,0.13) !important;
    // }
  `;
  document.head.appendChild(style);

  // ============================================================
  // ✅ SINGLE OBSERVER — watches everything, triggers on entry
  // ============================================================
  const seen = new WeakSet();

  const globalObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          const el = entry.target;
          const delay = parseInt(el.dataset.animDelay || "0", 10);
          setTimeout(function () {
            el.classList.add("anim-in");
          }, delay);
          globalObserver.unobserve(el);
        }
      });
    },
    {
      threshold: 0.05, // ✅ Triggers very early — just 5% visible
      rootMargin: "0px 0px -30px 0px",
    },
  );

  // ============================================================
  // ✅ REGISTER FUNCTION
  // ============================================================
  function anim(el, cls, delay) {
    if (!el) return;
    el.classList.add(cls);
    el.dataset.animDelay = delay || 0;
    globalObserver.observe(el);
  }

  function animAll(selector, cls, baseDelay, stagger, parent) {
    const root = parent || document;
    root.querySelectorAll(selector).forEach(function (el, i) {
      anim(el, cls, (baseDelay || 0) + i * (stagger || 100));
    });
  }

  // ============================================================
  // ✅ FAST SCROLL PROTECTION
  // Only kicks in if scroll is truly rapid — shows ONLY elements
  // that are FULLY above viewport (user has 100% passed them)
  // ============================================================
  window.addEventListener(
    "scroll",
    function () {
      document
        .querySelectorAll(
          ".anim-up:not(.anim-in), .anim-left:not(.anim-in), .anim-right:not(.anim-in), " +
            ".anim-scale:not(.anim-in), .anim-flip:not(.anim-in), .anim-blur:not(.anim-in), " +
            ".anim-pop:not(.anim-in), .anim-down:not(.anim-in)",
        )
        .forEach(function (el) {
          const rect = el.getBoundingClientRect();
          // Only snap visible if element is FULLY scrolled PAST (above viewport)
          if (rect.bottom < -100) {
            el.style.transition = "none";
            el.classList.add("anim-in");
            // Restore transition after snap
            setTimeout(function () {
              el.style.transition = "";
            }, 50);
          }
        });
    },
    { passive: true },
  );

  // ============================================================
  // ✅ SECTION: curated-categories
  // ============================================================
  (function () {
    const s = document.querySelector(".curated-categories");
    if (!s) return;

    anim(s.querySelector(".curated-categories__title"), "anim-flip", 0);
    anim(s.querySelector(".curated-categories__subtitle"), "anim-up", 180);

    s.querySelectorAll(".curated-categories__card").forEach(function (card, i) {
      anim(card, i % 2 === 0 ? "anim-left" : "anim-right", 100 + i * 120);
      card.classList.add("anim-card-hover");
    });

    s.querySelectorAll(".curated-categories__card-title").forEach(
      function (el, i) {
        anim(el, "anim-up", 200 + i * 100);
      },
    );
    s.querySelectorAll(".curated-categories__card-cta").forEach(
      function (el, i) {
        anim(el, "anim-up", 280 + i * 100);
      },
    );

    anim(s.querySelector(".curated-categories__promo"), "anim-scale", 300);
    anim(
      s.querySelector(".curated-categories__promo-eyebrow"),
      "anim-down",
      400,
    );
    anim(s.querySelector(".curated-categories__promo-quote"), "anim-flip", 500);
    anim(s.querySelector(".curated-categories__promo-btn"), "anim-up", 620);
  })();

  // ============================================================
  // ✅ SECTION: Story
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849516198__section_9d4JpR",
    );
    if (!s) return;

    anim(s.querySelector(".icon-block"), "anim-pop", 0);
    anim(
      s.querySelector(".text-block--AM2pwaHZiLzd3UytVZ__text_6Ee8Kr"),
      "anim-flip",
      150,
    );
    anim(
      s.querySelector(".text-block--AT2NYSlNTQW84ejlGb__text_qcqjYW"),
      "anim-blur",
      300,
    );
    anim(
      s.querySelector(".text-block--AVXV0NW9qblR5YjBpM__text_fDEcf3"),
      "anim-up",
      450,
    );
  })();

  // ============================================================
  // ✅ SECTION: Collection List
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849516198__collection_list_EiF4HR",
    );
    if (!s) return;

    anim(
      s.querySelector(".text-block--AQms0a3JGYnpXbjRNL__text_TNciqc"),
      "anim-left",
      0,
    );
    anim(
      s.querySelector(".link--AYVZVZWhLQU9VVDVVV__button_NbByFa"),
      "anim-right",
      100,
    );

    s.querySelectorAll("product-card").forEach(function (card, i) {
      anim(card, "anim-up", 150 + i * 120);
      card.classList.add("anim-card-hover");
    });

    s.querySelectorAll(".text-block[class*='product_title']").forEach(
      function (el, i) {
        anim(el, "anim-up", 200 + i * 120);
      },
    );

    s.querySelectorAll("product-price").forEach(function (el, i) {
      anim(el, "anim-up", 260 + i * 120);
    });
  })();

  // ============================================================
  // ✅ SECTION: Promo Banner
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849516198__section_KVKwdm",
    );
    if (!s) return;

    anim(
      s.querySelector(".text-block--AMDRULzlaWGtidXB0e__text_9kXPVN"),
      "anim-down",
      0,
    );
    anim(
      s.querySelector(".text-block--AVjVoamp0QU9COWM0S__text_G3FtgR"),
      "anim-left",
      150,
    );
    anim(
      s.querySelector(".text-block--AK2YzeVdWYUhDd3V5V__text_QbTAE8"),
      "anim-up",
      280,
    );
    anim(
      s.querySelector(".button--AdDdnOEVRVzR4Qk1Zc__button_BVDwnx"),
      "anim-scale",
      400,
    );
    anim(
      s.querySelector(".image-block--AenpvazI3aDN0N1ZqY__image_fk9N8r"),
      "anim-right",
      150,
    );
  })();

  // ============================================================
  // ✅ SECTION: Testimonials
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849516198__testimonials_8cPMtb",
    );
    if (!s) return;

    anim(s.querySelector(".testimonials-heading"), "anim-flip", 0);
    anim(s.querySelector(".testimonials-arrow--prev"), "anim-left", 300);
    anim(s.querySelector(".testimonials-arrow--next"), "anim-right", 300);

    s.querySelectorAll(".testimonials-slide").forEach(function (el, i) {
      anim(el, "anim-up", 150 + i * 120);
    });
    s.querySelectorAll(".testimonials-text").forEach(function (el, i) {
      anim(el, "anim-blur", 220 + i * 100);
    });
    s.querySelectorAll(".testimonials-author").forEach(function (el, i) {
      anim(el, "anim-up", 300 + i * 100);
    });
  })();

  // ============================================================
  // ✅ SECTION: Trust Badges
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849516198__section_eXFdFM",
    );
    if (!s) return;

    s.querySelectorAll(".icon-block").forEach(function (el, i) {
      anim(el, "anim-pop", i * 150);
    });
    s.querySelectorAll(".text-block[class*='h3']").forEach(function (el, i) {
      anim(el, "anim-up", 100 + i * 150);
    });
    s.querySelectorAll(
      ".text-block[class*='ARWl4'], .text-block[class*='AVm1'], .text-block[class*='AaDN']",
    ).forEach(function (el, i) {
      anim(el, "anim-blur", 180 + i * 150);
    });
  })();

  // // ============================================================
  // // ✅ SECTION: Contact
  // // ============================================================
  // (function () {
  //   const s = document.querySelector("#shopify-section-template--28113849516198__section_rftRGW");
  //   if (!s) return;

  //   anim(s.querySelector(".text-block--Aek1JQXlUNTA2VEdYV__text_8Bb3Cd"), "anim-flip",  0);
  //   anim(s.querySelector(".text-block--AK25aeDFrRXJUZXV4W__text_NbmdTY"), "anim-up",    150);
  //   anim(s.querySelector(".text-block--AZWZYdXBJdU9uMXgxd__text_HYp4Gg"), "anim-left",  280);
  //   anim(s.querySelector(".text-block--AdVBYOCtJRWEzakhpc__text_chRAXR"), "anim-left",  380);
  //   anim(s.querySelector(".text-block--ANlNuWHF2UXM5RVJmT__text_8jiMgi"), "anim-right", 100);
  //   anim(s.querySelector(".text-block--AYlNHUGdxQ0lyemdMW__text_DB3rxJ"), "anim-right", 220);
  //   anim(s.querySelector(".text-block--AczNVbE4vN2JZVDNNS__text_BtWVJA"), "anim-up",    340);

  //   s.querySelectorAll(".icon-block").forEach(function (el, i) {
  //     anim(el, "anim-pop", 280 + i * 120);
  //   });
  //   anim(s.querySelector("#shopify-block-AQmxQbFdFSDdoWCtoW__icon_Mp7Xrd"), "anim-pop", 420);
  // })();

  // ============================================================
  // ✅ SECTION: Contact
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849516198__section_rftRGW",
    );
    if (!s) return;

    anim(
      s.querySelector(".text-block--Aek1JQXlUNTA2VEdYV__text_8Bb3Cd"),
      "anim-flip",
      0,
    );
    anim(
      s.querySelector(".text-block--AK25aeDFrRXJUZXV4W__text_NbmdTY"),
      "anim-up",
      150,
    );
    anim(
      s.querySelector(".text-block--AZWZYdXBJdU9uMXgxd__text_HYp4Gg"),
      "anim-left",
      280,
    );
    anim(
      s.querySelector(".text-block--AdVBYOCtJRWEzakhpc__text_chRAXR"),
      "anim-left",
      380,
    );
    anim(
      s.querySelector(".text-block--ANlNuWHF2UXM5RVJmT__text_8jiMgi"),
      "anim-right",
      100,
    );
    anim(
      s.querySelector(".text-block--AYlNHUGdxQ0lyemdMW__text_DB3rxJ"),
      "anim-right",
      220,
    );
    anim(
      s.querySelector(".text-block--AczNVbE4vN2JZVDNNS__text_BtWVJA"),
      "anim-up",
      340,
    );

    s.querySelectorAll(".icon-block").forEach(function (el, i) {
      anim(el, "anim-pop", 280 + i * 120);
    });
    anim(
      s.querySelector("#shopify-block-AQmxQbFdFSDdoWCtoW__icon_Mp7Xrd"),
      "anim-pop",
      420,
    );

    // ✅ ADD THIS — catches GET DIRECTIONS link
    s.querySelectorAll("a").forEach(function (el, i) {
      anim(el, "anim-up", 400 + i * 80);
    });
  })();

  // ============================================================
  // ✅ SAFETY NET — reveals any elements stuck invisible
  // at the bottom of the page where observer never fires
  // ============================================================
  function revealStranded() {
    document
      .querySelectorAll(
        ".anim-up:not(.anim-in), .anim-left:not(.anim-in), .anim-right:not(.anim-in), " +
          ".anim-scale:not(.anim-in), .anim-flip:not(.anim-in), .anim-blur:not(.anim-in), " +
          ".anim-pop:not(.anim-in), .anim-down:not(.anim-in)",
      )
      .forEach(function (el) {
        const rect = el.getBoundingClientRect();
        // ✅ If element is anywhere in the visible viewport — show it
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add("anim-in");
        }
      });
  }

  // Run on scroll and on page load
  window.addEventListener("scroll", revealStranded, { passive: true });
  window.addEventListener("load", revealStranded);
  // Also run after a short delay for late-rendering elements
  setTimeout(revealStranded, 800);
});

// Full page animation about us
document.addEventListener("DOMContentLoaded", function () {
  // ============================================================
  // ✅ STYLES
  // ============================================================
  const style = document.createElement("style");
  style.textContent = `
    /* ✅ FIX: Prevent translateX animations from causing horizontal scroll */
    html, body { overflow-x: hidden; }

    .anim-up    { opacity: 0 !important; transform: translateY(70px) !important; }
    .anim-left  { opacity: 0 !important; transform: translateX(-80px) !important; }
    .anim-right { opacity: 0 !important; transform: translateX(80px) !important; }
    .anim-scale { opacity: 0 !important; transform: scale(0.75) !important; }
    .anim-flip  { opacity: 0 !important; transform: perspective(800px) rotateX(25deg) translateY(50px) !important; }
    .anim-blur  { opacity: 0 !important; filter: blur(10px) !important; transform: translateY(25px) !important; }
    .anim-pop   { opacity: 0 !important; transform: scale(0.4) rotate(-8deg) !important; }
    .anim-down  { opacity: 0 !important; transform: translateY(-50px) !important; }

    .anim-up, .anim-left, .anim-right,
    .anim-scale, .anim-flip, .anim-blur,
    .anim-pop, .anim-down {
      transition:
        opacity 1s cubic-bezier(0.22, 1, 0.36, 1),
        transform 1s cubic-bezier(0.22, 1, 0.36, 1),
        filter 1s ease !important;
      will-change: opacity, transform;
    }

    .anim-in {
      opacity: 1 !important;
      transform: none !important;
      filter: none !important;
    }

    // .anim-card-hover {
    //   transition: transform 0.4s ease, box-shadow 0.4s ease !important;
    // }
    // .anim-card-hover:hover {
    //   transform: translateY(-8px) scale(1.02) !important;
    //   box-shadow: 0 24px 60px rgba(0,0,0,0.13) !important;
    // }
  `;
  document.head.appendChild(style);

  // ============================================================
  // ✅ OBSERVER + REGISTER
  // ============================================================
  const seen = new WeakSet();

  const globalObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          const el = entry.target;
          const delay = parseInt(el.dataset.animDelay || "0", 10);
          setTimeout(function () {
            el.classList.add("anim-in");
          }, delay);
          globalObserver.unobserve(el);
        }
      });
    },
    {
      threshold: 0.05,
      rootMargin: "0px 0px -30px 0px",
    },
  );

  function anim(el, cls, delay) {
    if (!el) return;
    el.classList.add(cls);
    el.dataset.animDelay = delay || 0;
    globalObserver.observe(el);
  }

  // ============================================================
  // ✅ FAST SCROLL PROTECTION
  // ============================================================
  window.addEventListener(
    "scroll",
    function () {
      document
        .querySelectorAll(
          ".anim-up:not(.anim-in), .anim-left:not(.anim-in), " +
            ".anim-right:not(.anim-in), .anim-scale:not(.anim-in), " +
            ".anim-flip:not(.anim-in), .anim-blur:not(.anim-in), " +
            ".anim-pop:not(.anim-in), .anim-down:not(.anim-in)",
        )
        .forEach(function (el) {
          const rect = el.getBoundingClientRect();
          if (rect.bottom < -100) {
            el.style.transition = "none";
            el.classList.add("anim-in");
            setTimeout(function () {
              el.style.transition = "";
            }, 50);
          }
        });
    },
    { passive: true },
  );

  // ============================================================
  // ✅ SECTION 1 — Hero (custom_text_animation_left/right)
  // Already handled by your existing text + image animation JS
  // ============================================================

  // ============================================================
  // ✅ SECTION 2 — Founder Story
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28270802141350__founder_story_JeEFeq",
    );
    if (!s) return;

    // Label badge
    anim(s.querySelector(".founder-label"), "anim-pop", 0);

    // Main heading
    anim(s.querySelector(".founder-heading"), "anim-flip", 150);

    // Story text paragraphs stagger
    s.querySelectorAll(".story-text p").forEach(function (el, i) {
      anim(el, "anim-blur", 280 + i * 120);
    });

    // Divider line
    anim(s.querySelector(".divider-horizontal"), "anim-scale", 400);

    // Column titles
    s.querySelectorAll(".column-title").forEach(function (el, i) {
      anim(el, i === 0 ? "anim-left" : "anim-right", 500 + i * 150);
    });

    // Column text
    s.querySelectorAll(".column-text").forEach(function (el, i) {
      anim(el, "anim-up", 620 + i * 150);
    });
  })();

  // ============================================================
  // ✅ SECTION 3 — "We don't just sell products"
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28270802141350__section_hjDLCt",
    );
    if (!s) return;

    anim(
      s.querySelector(".text-block--AY2JOYnk4SnJzMmRyV__text_b4xxJm"),
      "anim-flip",
      0,
    );
    anim(
      s.querySelector(".text-block--AbFRXTXVFRGJLN2kxS__text_fQXJQT"),
      "anim-blur",
      200,
    );
    anim(
      s.querySelector(".button--AdnpGdGVZZWlmZzFmQ__button_BmxiLi"),
      "anim-scale",
      380,
    );
  })();

  // ============================================================
  // ✅ SECTION 4 — "What We Offer" heading
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28270802141350__section_4mT7Qg",
    );
    if (!s) return;

    anim(
      s.querySelector(".text-block--AWGt5dlY5bklHOXVBQ__text_46UdMy"),
      "anim-flip",
      0,
    );
  })();

  // ============================================================
  // ✅ SECTION 5 — What We Offer (4 product cards)
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28270802141350__section_PfkHj6",
    );
    if (!s) return;

    // All image blocks stagger up
    const images = s.querySelectorAll(".image-block");
    images.forEach(function (el, i) {
      anim(el, "anim-up", i * 150);
      el.classList.add("anim-card-hover");
    });

    // Labels under each image
    const labels = [
      ".text-block--AL2IyOTFjajhwQklKb__text_z4TC6b",
      ".text-block--ATWcxTFI3K1A2Q081U__text_gniRNY",
      ".text-block--AZGEySUZEd3VuL1V3R__text_VYByK4",
      ".text-block--AYnlpSkV1bmhCa1dON__text_PdwG7y",
    ];
    labels.forEach(function (sel, i) {
      anim(s.querySelector(sel), "anim-up", 180 + i * 150);
    });
  })();

  // ============================================================
  // ✅ SECTION 6 — Brand Philosophy
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28270802141350__section_LiU3TP",
    );
    if (!s) return;

    anim(
      s.querySelector(".text-block--AZjVJWTA5TGVCcWwxN__text_FjqVNQ"),
      "anim-flip",
      0,
    );
    anim(
      s.querySelector(".text-block--ATytZV2g2bDhLSU5YS__text_CGyjcA"),
      "anim-blur",
      200,
    );
  })();

  // ============================================================
  // ✅ SECTION 7 — Handpicked Elegance (2 philosophy cards)
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28270802141350__section_YWH4Jm",
    );
    if (!s) return;

    // Card 1 — left
    anim(
      s.querySelector(".text-block--AV0ovdDk3UGdQQlBKb__text_twFRCG"),
      "anim-left",
      0,
    );
    anim(
      s.querySelector(".text-block--Aa3kyZnlwOXlFQmJyU__text_dc8bcq"),
      "anim-up",
      180,
    );

    // Card 2 — right
    anim(
      s.querySelector(".text-block--Ab1E5eFFrR0xYSlJyd__text_ThFyUy"),
      "anim-right",
      150,
    );
    anim(
      s.querySelector(".text-block--AWTc3dG5nUUNVaTNlY__text_zd34k9"),
      "anim-up",
      300,
    );

    // Both cards as a whole
    s.querySelectorAll("[data-testid='group-block']").forEach(function (el, i) {
      anim(el, i % 2 === 0 ? "anim-left" : "anim-right", i * 150);
      el.classList.add("anim-card-hover");
    });
  })();
});

// Full page animation contact us
document.addEventListener("DOMContentLoaded", function () {
  // ============================================================
  // ✅ STYLES
  // ============================================================
  const style = document.createElement("style");
  style.textContent = `
    .anim-up    { opacity: 0 !important; transform: translateY(70px) !important; }
    .anim-left  { opacity: 0 !important; transform: translateX(-80px) !important; }
    .anim-right { opacity: 0 !important; transform: translateX(80px) !important; }
    .anim-scale { opacity: 0 !important; transform: scale(0.75) !important; }
    .anim-flip  { opacity: 0 !important; transform: perspective(800px) rotateX(25deg) translateY(50px) !important; }
    .anim-blur  { opacity: 0 !important; filter: blur(10px) !important; transform: translateY(25px) !important; }
    .anim-pop   { opacity: 0 !important; transform: scale(0.4) rotate(-8deg) !important; }
    .anim-down  { opacity: 0 !important; transform: translateY(-50px) !important; }

    .anim-up, .anim-left, .anim-right,
    .anim-scale, .anim-flip, .anim-blur,
    .anim-pop, .anim-down {
      transition:
        opacity 1s cubic-bezier(0.22, 1, 0.36, 1),
        transform 1s cubic-bezier(0.22, 1, 0.36, 1),
        filter 1s ease !important;
      will-change: opacity, transform;
    }

    .anim-in {
      opacity: 1 !important;
      transform: none !important;
      filter: none !important;
    }

    /* Form fields animate in */
    .anim-field {
      opacity: 0;
      transform: translateY(30px);
      transition: opacity 0.7s ease, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1) !important;
    }
    .anim-field.anim-in {
      opacity: 1 !important;
      transform: none !important;
    }

    /* Focus glow on form inputs */
    .contact-form__input:focus {
      outline: none;
      box-shadow: 0 0 0 2px #ecb613 !important;
      border-color: #ecb613 !important;
      transition: box-shadow 0.3s ease !important;
    }

    // .anim-card-hover {
    //   transition: transform 0.4s ease, box-shadow 0.4s ease !important;
    // }
    // .anim-card-hover:hover {
    //   transform: translateY(-6px) !important;
    //   box-shadow: 0 20px 50px rgba(0,0,0,0.10) !important;
    // }
  `;
  document.head.appendChild(style);

  // ============================================================
  // ✅ OBSERVER + REGISTER
  // ============================================================
  const seen = new WeakSet();

  const globalObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !seen.has(entry.target)) {
          seen.add(entry.target);
          const el = entry.target;
          const delay = parseInt(el.dataset.animDelay || "0", 10);
          setTimeout(function () {
            el.classList.add("anim-in");
          }, delay);
          globalObserver.unobserve(el);
        }
      });
    },
    {
      threshold: 0.05,
      rootMargin: "0px 0px -30px 0px",
    },
  );

  function anim(el, cls, delay) {
    if (!el) return;
    el.classList.add(cls);
    el.dataset.animDelay = delay || 0;
    globalObserver.observe(el);
  }

  // ============================================================
  // ✅ FAST SCROLL PROTECTION
  // ============================================================
  window.addEventListener(
    "scroll",
    function () {
      document
        .querySelectorAll(
          ".anim-up:not(.anim-in), .anim-left:not(.anim-in), " +
            ".anim-right:not(.anim-in), .anim-scale:not(.anim-in), " +
            ".anim-flip:not(.anim-in), .anim-blur:not(.anim-in), " +
            ".anim-pop:not(.anim-in), .anim-down:not(.anim-in), " +
            ".anim-field:not(.anim-in)",
        )
        .forEach(function (el) {
          const rect = el.getBoundingClientRect();
          if (rect.bottom < -100) {
            el.style.transition = "none";
            el.classList.add("anim-in");
            setTimeout(function () {
              el.style.transition = "";
            }, 50);
          }
        });
    },
    { passive: true },
  );

  // ============================================================
  // ✅ SECTION 1 — Hero (handled by existing left/right scripts)
  // ============================================================

  // ============================================================
  // ✅ SECTION 2 — Contact Form
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849647270__form",
    );
    if (!s) return;

    // Heading + subtext
    anim(
      s.querySelector(".text-block--ARjViVTFYaFpZdWdGL__text_L4iExP"),
      "anim-flip",
      0,
    );
    anim(
      s.querySelector(".text-block--AUGw3c1M1UEFzWXlFS__text_ncXanR"),
      "anim-blur",
      180,
    );

    // Form fields stagger in one by one
    const nameInput = s.querySelector("#ContactForm-name");
    const emailInput = s.querySelector("#ContactForm-email");
    const phoneInput = s.querySelector("#ContactForm-phone");
    const textarea = s.querySelector("#ContactForm-body");
    const submitBtn = s.querySelector(".submit-button");

    [nameInput, emailInput, phoneInput, textarea, submitBtn].forEach(
      function (el, i) {
        if (!el) return;
        el.classList.add("anim-field");
        el.dataset.animDelay = 300 + i * 120;
        globalObserver.observe(el);
      },
    );
  })();

  // ============================================================
  // ✅ SECTION 3 — Quick Ways to Reach Us
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849647270__section_6KNPQk",
    );
    if (!s) return;

    // Main heading + subtitle
    anim(
      s.querySelector(".text-block--Aa2tiVnJpYXdTQkN1Z__text_3xDUzW"),
      "anim-flip",
      0,
    );
    anim(
      s.querySelector(".text-block--AalU4SzRsazkzeFM4V__text_YwnVQK"),
      "anim-blur",
      180,
    );

    // Description text
    anim(
      s.querySelector(".text-block--ARkc0bVh4TDcwVFNCW__text_6WKdkE"),
      "anim-up",
      300,
    );

    // Email icon + link
    anim(
      s.querySelector("#shopify-block-AQVJyYkNEZS9reUN3a__icon_DV8bXB"),
      "anim-pop",
      400,
    );
    anim(
      s.querySelector(".text-block--AbzZ0cmtZeER0eHJvb__text_eU73mq"),
      "anim-left",
      480,
    );

    // Phone icon + link
    anim(
      s.querySelector("#shopify-block-Adk8wU0lPMDhYTTVWU__icon_jGDdti"),
      "anim-pop",
      550,
    );
    anim(
      s.querySelector(".text-block--AcktWcDFnZ1NnU0lJY__text_kwtN77"),
      "anim-left",
      620,
    );

    // Studio address
    anim(
      s.querySelector(".text-block--AY0thenNlaDl2ODNKS__text_ABrPtT"),
      "anim-right",
      350,
    );
    anim(
      s.querySelector(".text-block--ASVRyOWdiVkw3TDZTL__text_c4B4X6"),
      "anim-up",
      460,
    );

    // Get Directions button
    anim(
      s.querySelector(".text-block--AZ2dZU3ozcGpBc1gvR__text_LqLECD"),
      "anim-scale",
      560,
    );
    anim(
      s.querySelector("#shopify-block-AbmNUMUk3WlFocGs2V__icon_cyaGQH"),
      "anim-pop",
      620,
    );

    // Map iframe — fade in last
    const mapContainer = s.querySelector(".map-container");
    if (mapContainer) anim(mapContainer, "anim-up", 700);
  })();

  // ============================================================
  // ✅ SECTION 4 — "We respond within 24 hours"
  // ============================================================
  (function () {
    const s = document.querySelector(
      "#shopify-section-template--28113849647270__section_DCaMNV",
    );
    if (!s) return;

    anim(
      s.querySelector(".text-block--AdlVTRmRNcjdGVG1Na__text_wVYcAi"),
      "anim-flip",
      0,
    );
    anim(
      s.querySelector(".text-block--AZmxyTGNNZDQ4SWNuR__text_rFfMhD"),
      "anim-blur",
      220,
    );
  })();
});
